import React from "react";

export function EyeIcon() {
  return <i className="fa-regular fa-eye"></i>;
}
